<template>
  <tr>
    <th
      style="width: 10px"
      rowspan="2"
      class="text-center bg-blue text-light align-middle fixColumn"
    >
      شیفت
    </th>
    <th
      v-for="(day, index) in dataList"
      :key="index"
      scope="col"
      class="text-center bg-blue text-light"
    >
      {{ day.dayName }}
      <small class="d-block">{{ day.persianDate }}</small>
      <small
        class="d-block gregorianDateClass"
        v-if="this.$store.getters.isOverseas"
        >{{ getGregorianDateOfSession(day.englishDate) }}</small
      >
    </th>
  </tr>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dataList: {
      type: Array,
      required: false,
    },
  },
  methods: {
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
  },
};
</script>

<style scoped>
.fixColumn {
  z-index: 1;
  position: sticky;
  right: 0px;
}
th {
  font-weight: normal;
}
</style>
